<label class="lbl" for="sm-search">Find a suburb</label>
<input id="sm-search" pInputText type="search" class="w-full" placeholder="e.g. Randwick" autocomplete="off" [(ngModel)]="state.searchText" (ngModelChange)="state.search()" />
<ul class="results" *ngIf="state.results.length">
  <li *ngFor="let r of state.results" (click)="mapTools.pickResult(r.code)">
    <span>{{ r.name }}</span>
    <span class="sub">{{ r.regionId ? catalogue.regionName(r.regionId) : '—' }}{{ r.covered ? ' · has a page' : '' }}</span>
  </li>
</ul>
